import { PetsApi } from './generated-src';
import { getAppSetting } from '../config/AppSettings';
import { Configuration } from "./generated-src/configuration";

export default function() {
  const apiBasePath = `https://${getAppSetting('apiUrl')}/jwt`;
  return new PetsApi(new Configuration({basePath: apiBasePath}));
}
